module.exports = __webpack_public_path__ + "img/bar-waiting.69b66fd4.svg";